<div class="container-fluid">
  <div class="p-3">
    <h1>Notifications</h1>
    <div *ngIf="isConfigurationLoading; else loaded" class="pl-3">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading Notifications Configuration...</span>
      </div>
      <span>Loading Notifications Configuration...</span>
    </div>
    <ng-template #loaded>
      <app-message></app-message>
      <div *ngIf="isSaving" class="pl-3">
        <div class="spinner-border" role="status">
          <span class="sr-only">Saving Notifications Configuration...</span>
        </div>
        <span>Saving Notifications Configuration...</span>
      </div>

      <form class="form-group" *ngIf="configuration && !isSaving" ngNativeValidate>
        <div class="row">
          <div class="col-xl-6 col-md-8 col-sm-12">
            <label for="community-compliance-email">Community Compliance Contact Email: (required)</label>
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     id="community-compliance-email"
                     name="community-compliance-email"
                     required="true"
                     [(ngModel)]="configuration.comcontact"
                     #communityComplianceEmail="ngModel"
                     pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*">
              <div class="input-group-append">
                <span class="input-group-text">@state.mn.us</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="communityComplianceEmail.invalid && (communityComplianceEmail.dirty || communityComplianceEmail.touched)">
          <div class="col-xl-6 col-md-8 col-sm-12">
            <div *ngIf="communityComplianceEmail.hasError('required')" class="alert alert-danger">
              The Community Compliance Contact Email is required.
            </div>
            <div *ngIf="communityComplianceEmail.hasError('pattern')" class="alert alert-danger">
              The Community Compliance Contact Email is not properly formatted.
            </div>
          </div>
        </div>
        <div class="row pt-2">
          <div class="col-xl-6 col-md-8 col-sm-12">
            <label for="non-community-compliance-email">Non-Community Compliance Contact Email: (required)</label>
            <div class="input-group">
              <input type="text"
                     class="form-control"
                     id="non-community-compliance-email"
                     name="non-community-compliance-email"
                     required="true"
                     [(ngModel)]="configuration.noncomcontact"
                     #nonCommunityComplianceEmail="ngModel"
                     pattern="[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*">
              <div class="input-group-append">
                <span class="input-group-text">@state.mn.us</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="nonCommunityComplianceEmail.invalid && (nonCommunityComplianceEmail.dirty || nonCommunityComplianceEmail.touched)">
          <div class="col-xl-6 col-md-8 col-sm-12">
            <div *ngIf="nonCommunityComplianceEmail.hasError('required')" class="alert alert-danger">
              The Non-Community Compliance Contact Email is required.
            </div>
            <div *ngIf="nonCommunityComplianceEmail.hasError('pattern')" class="alert alert-danger">
              The Non-Community Compliance Contact Email is not properly formatted.
            </div>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-12">
            <input type="submit" value="Save" class="btn btn-primary" (click)="save()" [disabled]="communityComplianceEmail.invalid || nonCommunityComplianceEmail.invalid"/>
          </div>
        </div>
      </form>

      <div *ngIf="error">
        <div class="card">
          <div class="card-body">
            <h2>Error</h2>
            <p>{{ error }}</p>
          </div>
        </div>
      </div>
    </ng-template>

    <app-notification-email></app-notification-email>
  </div>
</div>
